import {
  Configuration,
  InvestorIssueApi,
  InvestorOrdersApi,
  InvestorPortfolioApi,
  InvestorProfileApi,
  InvestorProfilesApi,
  InvestorReturnsApi,
  InvestorUpdatesApi,
  LeadsApi
} from '~/services/generated/client';

export function useApi() {
  const { public: { bondsApiUrl: basePath } } = useRuntimeConfig();

  const configuration = new Configuration({ basePath });

  const investorOrdersApi = computed(() => new InvestorOrdersApi(configuration));
  const investorIssueApi = computed(() => new InvestorIssueApi(configuration));
  const investorProfileApi = computed(() => new InvestorProfileApi(configuration));
  const investorProfilesApi = computed(() => new InvestorProfilesApi(configuration));
  const investorReturnsApi = computed(() => new InvestorReturnsApi(configuration));
  const investorPortfolioApi = computed(() => new InvestorPortfolioApi(configuration));
  const leadsApi = computed(() => new LeadsApi(configuration));
  const investorActualityApi = computed(() => new InvestorUpdatesApi(configuration));

  return {
    investorOrdersApi: readonly(investorOrdersApi),
    investorIssueApi: readonly(investorIssueApi),
    investorProfileApi: readonly(investorProfileApi),
    investorProfilesApi: readonly(investorProfilesApi),
    investorReturnsApi: readonly(investorReturnsApi),
    investorPortfolioApi: readonly(investorPortfolioApi),
    leadsApi: readonly(leadsApi),
    investorActualityApi: readonly(investorActualityApi),
  };
}
